import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import useAbility from "../../hooks/useAbility";
import CreateButton from "../common/CreateButton";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function CreateOfferButton(): JSX.Element | null {
  const { t } = useTranslation("editor-offers");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const orgaOptions = useSelector(
    (state: AppState) =>
      state.fetchReducer.orga_config.data?.organization_options,
  );

  const { canAccess } = useAbility();

  const { project: canAccessProject } = canAccess(orgaOptions);

  if (!canAccessProject.offersWrite) return null;

  return (
    <CreateButton
      href={`${PROJECTS_ROUTE}/${projectSlug}/offers/new`}
      label={t("createOffer")}
    />
  );
}

export default CreateOfferButton;
